// Servicio de autenticación del módulo administrador.
// Guarda el JWT y los datos del usuario en localStorage (ver sesion.js).

import { apiFetch, json } from './apiFetch';
import { getToken, getUsuario, guardarSesion, limpiarSesion } from './sesion';

export { getToken, getUsuario };

const CLAVE_INSTITUCION_ADMIN = 'admin_institucion';

const mapearUsuario = (data, expiraEn) => ({
  id: data.id,
  nombre: data.nombre,
  email: data.email,
  rol: data.rol,
  // Null para usuarios de plataforma (SuperAdmin).
  institucion: data.institucion || null,
  // Ids de categorías raíz asignadas (sólo publicadores).
  categoriasRaiz: data.categoriasRaiz || [],
  expiraEn,
});

export const login = async (email, password) => {
  // El email se recorta (evita espacios del autocompletado); la contraseña se envía tal cual.
  const data = await apiFetch('/api/auth/login', {
    method: 'POST',
    ...json({ email: email.trim(), password }),
  });

  const usuario = mapearUsuario(data, data.expiraEn);
  guardarSesion(data.token, usuario);
  return usuario;
};

// Vuelve a leer rol, institución y alcance del servidor (por si cambiaron desde el login).
export const refrescarSesion = async () => {
  const actual = getUsuario();
  const token = getToken();
  if (!actual || !token) return null;
  const data = await apiFetch('/api/auth/yo', { auth: true });
  const usuario = mapearUsuario(data, actual.expiraEn);
  guardarSesion(token, usuario);
  return usuario;
};

export const logout = () => {
  limpiarSesion();
  localStorage.removeItem(CLAVE_INSTITUCION_ADMIN);
};

export const isAuthenticated = () => {
  const token = getToken();
  const usuario = getUsuario();
  if (!token || !usuario) return false;
  // Verificar expiración del token (la fuente de verdad es el 401 del backend).
  if (usuario.expiraEn && new Date(usuario.expiraEn) <= new Date()) {
    logout();
    return false;
  }
  return true;
};

// Institución activa elegida por un SuperAdmin (los demás usuarios tienen la suya fija).
export const getInstitucionAdmin = () => {
  try {
    return localStorage.getItem(CLAVE_INSTITUCION_ADMIN) || null;
  } catch {
    return null;
  }
};

export const setInstitucionAdmin = (slug) => {
  try {
    if (slug) localStorage.setItem(CLAVE_INSTITUCION_ADMIN, slug);
    else localStorage.removeItem(CLAVE_INSTITUCION_ADMIN);
  } catch {
    /* almacenamiento no disponible */
  }
};
